import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  generalCountryAll: [],
  generalCountry: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const generalCountrySlice = createSlice({
  name: "generalCountry",
  initialState,
  reducers: {
    setGeneralCountryAll: (state, action) => {
      state.generalCountryAll = action.payload;
    },
    setGeneralCountry: (state, action) => {
      state.generalCountry = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setGeneralCountryAll,
  setGeneralCountry,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = generalCountrySlice.actions;

export default generalCountrySlice.reducer;
